module.exports = __webpack_public_path__ + "img/beez_slogan.f45c96a3.svg";